import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/documents/templates")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$dealership/deal-packets/templates",
      params,
    })
  },
})
